import { Fragment } from "react";
import { focusIndustries, processSteps } from "../../data/home";
import { useInView } from "../../hooks/useInView";
import { Icon } from "../ui/Icon";

const processIcons = [
  "/assets/icons/process-submit.svg",
  "/assets/icons/process-match.svg",
  "/assets/icons/process-receive.svg",
  "/assets/icons/process-finalize.svg",
] as const;

export function IndustriesInsightsProcess() {
  const focusView = useInView<HTMLDivElement>(0.12);
  const processView = useInView<HTMLDivElement>(0.24);

  return (
    <div className="container lower-content focus-process-layout">
      <section id="focus" className="focus-section" aria-labelledby="focus-heading">
        <div className="focus-heading">
          <p>Current Focus</p>
          <h2 id="focus-heading">Focused access, with room for specific requests.</h2>
          <span>We stay close to categories where our current relationships are most relevant, while assessing other requirements case by case.</span>
        </div>
        <div ref={focusView.ref} className={`focus-grid reveal-group ${focusView.visible ? "is-visible" : ""}`}>
          {focusIndustries.map((industry, index) => (
            <article className="focus-card" key={industry.name} style={{ "--delay": `${index * 70}ms` } as React.CSSProperties}>
              <div><Icon name={industry.icon} size={29} /></div>
              <h3>{industry.name}</h3>
              <p>{industry.description}</p>
              {industry.cta ? <a href="#sourcing-request">{industry.cta} <span aria-hidden="true">→</span></a> : null}
            </article>
          ))}
        </div>
      </section>
      <section id="how-it-works" className="process-section" aria-labelledby="process-heading">
        <div className="process-title">
          <h2 id="process-heading">How It Works</h2>
          <p>A clear buyer-side sourcing process</p>
        </div>
        <div ref={processView.ref} className={`process-track ${processView.visible ? "is-visible" : ""}`}>
          {processSteps.map((step, index) => (
            <Fragment key={step.title}>
              <article className="process-step" style={{ "--delay": `${index * 130}ms` } as React.CSSProperties}>
                <div className="process-marker">
                  <strong>{index + 1}</strong>
                  <img src={processIcons[index]} alt="" aria-hidden="true" />
                </div>
                <div className="process-copy"><h3>{step.title}</h3><p>{step.description}</p></div>
              </article>
              {index < processSteps.length - 1 ? <div className="process-connector" aria-hidden="true" /> : null}
            </Fragment>
          ))}
        </div>
      </section>
    </div>
  );
}
